import ScalarIconCloud_vue_vue_type_script_setup_true_lang_default from "./ScalarIconCloud.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconCloud.vue
var ScalarIconCloud_default = ScalarIconCloud_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconCloud_default as default };

//# sourceMappingURL=ScalarIconCloud.js.map